import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function Error403() {
  return (
    <div className="min-h-[70vh] bg-brand-light flex items-center justify-center py-16 px-6">
      <Helmet>
        <title>403 - Adgang forbudt | SKT Byg</title>
        <meta name="description" content="Du har ikke tilladelse til at tilgå denne side hos SKT Byg." />
      </Helmet>

      <div className="text-center max-w-md space-y-6">
        <div className="inline-flex items-center justify-center w-20 h-24 rounded-2xl bg-rose-100 text-rose-600 mb-4">
          <span className="font-display font-extrabold text-5xl">403</span>
        </div>
        <h1 className="text-3xl font-extrabold text-brand-dark">Adgang forbudt</h1>
        <p className="text-brand-dark/70 leading-relaxed">
          Beklager! Du har ikke tilladelse til at tilgå denne side eller ressource.
        </p>
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-brand-dark hover:bg-brand-accent text-white font-bold rounded-xl transition-all duration-300 cursor-pointer shadow-md"
          >
            <i className="fa-solid fa-house"></i>
            <span>Gå til forsiden</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
